/**
 * Rewrites a file's name to a `.mp4` extension (and mime to `video/mp4`) without touching its bytes.
 *
 * Why: video captured on device is often delivered in a different container (e.g. `.mov` on iOS).
 * Some downstream consumers of the uploaded file — notably OpenAI — reject those containers by
 * extension even when the underlying stream is compatible, and simply presenting the same bytes as
 * `.mp4` is enough for them to accept it. The uploader derives the sent mime type from the filename,
 * so renaming here is what actually changes what the backend/consumer sees.
 */
export function renameToMp4(file: File): File {
  const dotIndex = file.name.lastIndexOf('.');
  const baseName = dotIndex > 0 ? file.name.slice(0, dotIndex) : file.name;
  return new File([file], `${baseName}.mp4`, {
    type: 'video/mp4',
    lastModified: file.lastModified,
  });
}
